// extracted by mini-css-extract-plugin
export default {"imageWrapper":"dU-z","hovered":"eU-z","hoverImage":"fU-z","mainImage":"gU-z","imageNoBackground":"hU-z","fullSizeImage":"iU-z"};